import React, { useState, useHook, useEffect, useRef } from "react";
import Header from "../Header";
import SideBar from "../SideBar";
import Footer from "../Footer";
import { get, post, put, deleteM } from "../../utility/Adapter";
import DataTable from "react-data-table-component";
import { withParams } from "../HOC";

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { info, success } from "@pnotify/core";
import "@pnotify/core/dist/PNotify.css";
import "@pnotify/core/dist/BrightTheme.css";
import * as Confirm from "@pnotify/confirm";
import "@pnotify/confirm/dist/PNotifyConfirm.css";

const Acknowledged = () => {
    const [candidates, setCandidates] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const batchDelete = () => {
        success({
            title: "Confirmation",
            text: "Are you sure you want to delete the selected candidates?",
            modules: new Map([
                [
                    Confirm,
                    {
                        confirm: true,
                        buttons: [
                            {
                                text: "Ok",
                                primary: true,
                                click: (notice) => {
                                    notice.close();
                                    const candidate_ids = selectedRows.map(
                                        (row) => row.candidate_id
                                    );
                                    post("admin/candidates/batch-delete", {
                                        candidate_ids: candidate_ids,
                                    })
                                        .then(async function (response) {
                                            _loadCandidates(1);
                                            success({
                                                title: "SUCCESS",
                                                text: "Successfully deleted selected candidates",
                                            });
                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                        })
                                        .finally(() => {
                                            setSelectedRows([]);
                                        });
                                },
                            },
                            {
                                text: "Cancel",
                                click: (notice) => {
                                    notice.close();
                                },
                            },
                        ],
                    },
                ],
            ]),
        });
    };

    useEffect(function () {
        _loadCandidates(1);
    }, []);

    const _loadCandidates = (page) => {
        get("admin/candidates/acknologement/" + page)
            .then(async function (response) {
                setCandidates(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const columns = [
        {
            name: (
                <input
                    type="checkbox"
                    onChange={(e) => {
                        const isChecked = e.target.checked;
                        const newSelectedRows = isChecked ? candidates : [];
                        setSelectedRows(newSelectedRows);
                    }}
                />
            ),
            selector: (row) => (
                <input
                    type="checkbox"
                    checked={selectedRows.some(
                        (selectedRow) => selectedRow.candidate_id === row.candidate_id
                    )}
                    onChange={() => {
                        const isSelected = selectedRows.some(
                            (selectedRow) => selectedRow.candidate_id === row.candidate_id
                        );
                        if (isSelected) {
                            setSelectedRows(
                                selectedRows.filter(
                                    (selectedRow) =>
                                        selectedRow.candidate_id !== row.candidate_id
                                )
                            );
                        } else {
                            setSelectedRows([...selectedRows, row]);
                        }
                    }}
                />
            ),
        },
        {
            name: "#",
            selector: (row, index) => index + 1,
        },
        {
            name: "Name",
            selector: (row) => (
                <a href={"/candidate/" + row.candidate_id} target="_blank">
                    <span class="text-capitalize" id="contactName">
                        {row.candidate_first_name + " " + row.candidate_last_name}
                    </span>
                </a>
            ),
        },
        {
            name: "Phone",
            selector: (row) => row.candidate_phone,
        },
        {
            name: "NL",
            selector: (row) => (row.candidate_licence === "Y" ? "Yes" : "No"),
        },
        {
            name: "Documents",
            selector: (row) => row.documents_count,
        },
        {
            name: "Read",
            selector: (row) => row.candidate_brochure_read,
        },
        {
            name: "Actions",
            selector: (row) => (
                <>
                    <a
                        title="Remove from recommended"
                        style={{ color: "#000", marginRight: "5px" }}
                        href={"#"}
                        onClick={() => _remove(row.candidate_id)}
                    >
                        <span class="badge bg-outline-primary group" id="contactGroup">
                            Mark as Agreement Signed
                        </span>
                    </a>
                    <a
                        title="Mark as Not Signed"
                        style={{ color: "#000" }}
                        href={"#"}
                        onClick={() => _notSigned(row.candidate_id)}
                    >
                        <span class="badge bg-outline-danger group" id="contactGroup">
                            Not Signed
                        </span>
                    </a>
                    <a
                        title="Mark as Dropped"
                        style={{ color: "#000" }}
                        href={"#"}
                        onClick={() => _drop(row.candidate_id)}
                    >
                        <span class="badge bg-outline-danger group" id="contactGroup">
                            Dropped
                        </span>
                    </a>
                </>
            ),
        },
    ];

    var documentStatus = {
        0: "Pending",
        1: "Submitted",
        2: "Waiting Proposal",
        3: "Waiting Payment",
        4: "Translation Progress",
        5: "Translation Under Review",
        6: "Completed",
    };

    var languageLevels = {
        NOT_ENTROLLED: "Not yet enrolled",
        A1_ENTROLLED: "A1 Enrolled",
        A1_COMPLETE: "A2 Complete",
        B1_COMPLETE: "B1 Complete",
        B2_COMPLETE: "B2 Complete",
        C1_COMPLETE: "C1 Complete",
        C2_COMPLETE: "C2 Complete",
    };

    const _remove = (candidateId) => {
        confirmAlert({
            title: 'Confirm to mark as agreement signed',
            closeOnClickOutside: true,
            closeOnEsc: true,
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => _accept(candidateId)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    const _drop = (candidateId) => {
        confirmAlert({
            title: 'Confirm to mark as dropped',
            closeOnClickOutside: true,
            closeOnEsc: true,
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => _markAsDropped(candidateId)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    const _notSigned = (candidateId) => {
        confirmAlert({
            title: 'Confirm to mark as not signed',
            closeOnClickOutside: true,
            closeOnEsc: true,
            message: 'Are you sure to do this?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => _markAsNotSigned(candidateId)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    const _markAsDropped = (candidateId) => {
        post("admin/candidates/acknologement/drop", {
            candidate_id: candidateId
        })
            .then(async function (response) {
                _loadCandidates(1);

                success({
                    title: "SUCCESS",
                    text: "Successfully updated candidate status.",
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: notice => {
                                            notice.close();
                                        }
                                    }
                                ]
                            }
                        ]
                    ])
                });

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const _markAsNotSigned = (candidateId) => {
        post("admin/candidates/acknologement/mark_as_not_signed", {
            candidate_id: candidateId
        })
            .then(async function (response) {
                _loadCandidates(1);

                success({
                    title: "SUCCESS",
                    text: "Successfully updated candidate status.",
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: notice => {
                                            notice.close();
                                        }
                                    }
                                ]
                            }
                        ]
                    ])
                });

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const _accept = (candidateId) => {
        post("admin/candidates/acknologement/mark_as_agreement", {
            candidate_id: candidateId
        })
            .then(async function (response) {
                _loadCandidates(1);

                success({
                    title: "SUCCESS",
                    text:
                        "Successfully updated candidate status.",
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: notice => {
                                            notice.close();
                                        }
                                    }
                                ]
                            }
                        ]
                    ])
                });

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <>
            <Header />

            <main>
                <div class="container-fluid">
                    <div class="row">
                        {/* Menu Start */}
                        <SideBar />
                        {/*  Menu End */}

                        <div class="col">
                            <div class="page-title-container">
                                <div class="row g-0">
                                    <div class="col-auto mb-2 mb-md-0 me-auto">
                                        <div class="w-auto sw-md-30">
                                            <h1 class="mb-0 pb-0 display-4" id="title">
                                                RAL-Acknowledged Candidates
                                            </h1>
                                        </div>
                                    </div>
                                    <div class="w-100 d-md-none"></div>
                                </div>
                            </div>



                            <div class="card">
                                <div class="card-body p-2">
                                    {selectedRows.length > 0 && (
                                        <button
                                            type="button"
                                            class="btn btn-danger mb-2"
                                            onClick={batchDelete}
                                        >
                                            Delete Selected
                                        </button>
                                    )}
                                    <DataTable
                                        columns={columns}
                                        data={candidates}
                                        pagination
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Acknowledged;